import React from "react";
//import bannerImg from "../../../Assets/Images/bannar img 10.png";
import bannerImg2 from "../../../Assets/Images/Bannerimage2.jpg";
import { motion } from "framer-motion";
import "../Services/DataAnalytics.css";
import { Link } from "react-router-dom";

const DataAnalyticsBanner = () => {
  return (
    <div>
      <div
        className="data-analytics-content  position-relative gap-4 d-flex flex-column flex-lg-row   justify-content-around align-items-center"
        style={{
          margin: "0 auto",
        }}
      >
        <div className="data-ana-contain">
          <h2 className="fw-semibold data-analytics-heading text-dark mb-3 ">
            Data Analytics <br /> That Brings Clarity
          </h2>

          <p className="text-secondary data-analytics-text  ">
            Most of the teams are already collecting data. The problem is that
            it resides scattered across tools, dashboards and spreadsheets,
            saying very little when decisions need to be made. At Quad Theory
            Ltd, data analytics begins with the question - what do you need to
            know right now? We help teams to clean, connect and interpret their
            data so that patterns become visible and decisions are grounded, not
            guessed. The goal is simple. Turn numbers into clarity you can act
            on - not reports that get ignored.
          </p>

          <Link to="/contact-us">
            <motion.button
              type="button"
              className="btn px-5 py-3 rounded-pill"
              initial={{
                backgroundColor: "#19BDDE",
                boxShadow: "0 8px 20px rgba(25, 189, 222, 0.4)",
              }}
              whileHover={{
                backgroundColor: "#12869E",

                boxShadow: "none",
              }}
              transition={{ duration: 0.2 }}
              style={{
                border: "none",
                color: "#fff",
                fontWeight: "500",
                zIndex: 5,
                fontSize: "2rem",
              }}
            >
               Talk To A Data Expert
            </motion.button>
          </Link>
        </div>
        <div>
          <img className="img-fluid  data-ana-img" src={bannerImg2} alt="" />
        </div>
      </div>
    </div>
  );
};

export default DataAnalyticsBanner;
